import MainLayout from "@/components/layout/MainLayout.vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { required, maxLength , requiredIf, between} from "vuelidate/lib/validators";
import axios from "axios";
import { mapGetters } from "vuex";
import { fetchNotificationCount } from "@/services/common/notification-service";

export default {
    name: "createCourse",

    components: {
        MainLayout
    },

    data() {
        return {
            courseRequestForm: {
                category_id: "",
                category_name: "",
                course_title: "",
                course_explanation: "",
                course_details: "",
                certificate: "",
                course_type:"",
                fee:"",
                course_photo: "",
                access_type: "", // new field for access type
                access_expiry_duration: "" // new field for expiry duration
            },
            category: [],
            submitted: false,
            editor: ClassicEditor,
            editorConfig: {
                toolbar: [
                    "heading",
                    "|",
                    "bold",
                    "italic",
                    "bulletedList",
                    "numberedList"
                ]
            },
            video: false,
            fee: false,
            type: 0,
            course_photo: '',
            disabled: false,
        };
    },

    validations: {
        courseRequestForm: {
            category_name: {
                required
            },
            course_title: {
                required,
                maxLength: maxLength(100)
            },
            course_explanation: {
                required,
                maxLength: maxLength(1000)
            },
            course_details: {
                required,
                maxLength: maxLength(5000)
            },
            certificate: {
                required
            },
            course_type: {
                required
            },
            fee: {
                required: requiredIf(function () {
                    return this.type == 3;
                })
            },
            access_type: {
                required: requiredIf(function () {
                    return this.type == 3;
                })
            },
            access_expiry_duration: {
                required: requiredIf(function () {
                    return this.type == 3 && this.courseRequestForm.access_type == 2;
                }),
                between: between(1, 120)
            }
        }
    },

    computed: {
        ...mapGetters(["schoolId", "teacherId", "studentId", "userType"]),
    },

    methods: {
        onChange(event) {
            var optionValue = event.target.value;
            var optionText = event.target.options[event.target.options.selectedIndex].text;
            this.courseRequestForm.category_id = optionValue;
            this.courseRequestForm.category_name = optionText;
        },

        onCourseTypeChange(event) {
            this.type = event.target.value;
            if(event.target.value == 3) {
                this.video = true;
            } else {
                this.video = false;
            }
        },        

        submit() {
            this.submitted = true;
            this.fee = false;
        
            // Run all validations
            this.$v.$touch();
        
            if (this.$v.courseRequestForm.$invalid) {
                this.$el.dispatchEvent(new Event('validationFail'));
                return;
            }
            this.createCourse();
        },
        

        createCourse() {
            this.disabled = true;
            this.courseRequestForm.course_photo = this.course_photo;
            const categoryIds = this.category.map(item => item.category_id);
            if (!categoryIds.includes(parseInt(this.courseRequestForm.category_id))) {
              this.$notification.error("သင်တန်းအမျိုးအစားမှားနေပါသည်။ လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                timer: 3,
                position: "bottomCenter"
              });
              this.disabled = false;
              return;
            }
            var request = {
                category_id: this.courseRequestForm.category_id,
                category_name: this.courseRequestForm.category_name,
                course_title: this.courseRequestForm.course_title,
                course_explanation: this.courseRequestForm.course_explanation,
                course_details: this.courseRequestForm.course_details,
                certificate: this.courseRequestForm.certificate,
                course_type: this.courseRequestForm.course_type,
                course_photo: this.courseRequestForm.course_photo,
                access_type: this.courseRequestForm.access_type, // Include access_type in the request
                access_expiry_duration: this.courseRequestForm.access_expiry_duration // Include expiry duration if limited
            }
            if (this.userType == 'teacher') {
                request.teacher_id = this.teacherId;
            } else if (this.userType == 'school') {
                request.school_id = this.schoolId;
            }
            
            if(this.type == 3) {
                request.fee = this.courseRequestForm.fee
            }
            axios.post("my/course/create", JSON.stringify(request), {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    this.pg_status = true
                    this.teachers = response.data
                    if(this.type == 3) {
                        this.$router.push({
                            name: "manageCourse"
                        });
                    } else {
                        this.disabled = false;
                        this.$router.push({
                            name: "createClass"
                        });
                    }                    

                    this.$notification.success("လုပ်ဆောင်မှု အောင်မြင်ပါသည်။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                })
                .catch((error) => {
                    this.disabled = false;
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                })
        },

        getCategoryForCourse() {
            axios.get("course/categories")
                .then((response) => {
                    this.category = response.data;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log(error);
                });
        },

        chooseFiles(id) {
            document.getElementById(id).click();
        },

        onCoursePhotoChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return null;
            this.courseRequestForm.profile = e.target.files[0];
            let reader = new FileReader();
            reader.onload = (e) => {
                this.course_photo = e.target.result;
            };
            reader.readAsDataURL(files[0]);
        },
    },

    created() {
        this.getCategoryForCourse();
        fetchNotificationCount();
    }
};
